import JsFileDownloader from "js-file-downloader";
import { API_URLS } from "../../../../../utils/api-constants";

export const handlePdfFileDownload = async (
  sessionId: string,
  filename: string
) => {
  return new JsFileDownloader({
    url: `${process.env.REACT_APP_API_URL}${API_URLS.CUBE_COCKPIT}/${sessionId}/export`,
    filename,
  });
};
